<template>
  <div class="main-header">
    <button class="button" @click="$emit('menu')">
      <span class="mdi mdi-menu" v-if="isClose"></span>
      <span class="mdi mdi-close" v-else></span>
    </button>
    <div class="menu-title" id="vo-container">
      <div style="display: flex; flex-direction: column;">
        <p style="text-align: left;">
          <span class="mdi mdi-office-building" style="margin-right: 4px;"></span>
          エンゲージメントオフィス
        </p>
        <div style="display: flex; align-items: center; padding-left: 24px;">
          <p style="margin-top: 4px; font-size: 13px; color: #666;" @click="isEditOfficeName=true" v-if="!isEditOfficeName">
            {{officeName}}
          </p>
          <div style="display: flex;" v-if="isEditOfficeName">
            <input class="input is-small" v-model="officeName"/>
            <button class="button is-small" @click="updateVirtualOffice()">変更</button>
          </div>
        </div>
      </div>
      <div class="video-setting" style="display: flex; align-items: center;">
        <button @click="setWork(myStatus.isWork)" class="button" style="border-color: #a22; margin-right: 8px;" v-if="!isConnect">
          {{myStatus.isWork ? '退社' : '出社'}}
        </button>
        <b-tooltip label="Web会議中は変更できません" position="is-bottom" size="is-small" animated multilined v-if="isConnect">
          <button @click="setWork(myStatus.isWork)" class="button" style="border-color: #a22; margin-right: 8px;" :disabled="isConnect">
            {{myStatus.isWork ? '退社' : '出社'}}
          </button>
        </b-tooltip>
        <button @click="setWorkOutSide(myStatus.isWorkOutside)" class="button" style="border-color: #00a;" v-if="myStatus.isWork && !isConnect">
          {{myStatus.isWorkOutside ? '外出中から内勤に変更' : '外出中に変更'}}
        </button>
        <b-tooltip label="Web会議中は変更できません" position="is-bottom" size="is-small" animated multilined v-if="isConnect">
          <button @click="setWorkOutSide(myStatus.isWorkOutside)" class="button" style="border-color: #00a;" v-if="myStatus.isWork" :disabled="isConnect">
            {{myStatus.isWorkOutside ? '外出中から内勤に変更' : '外出中に変更'}}
          </button>
        </b-tooltip>
        <b-tooltip label="画面共有" position="is-bottom" size="is-small" animated multilined v-if="isConnect && !isShare">
          <button class="button" style="background: transparent; border: none;" @click="$emit('shareScreen', true)" :disabled="!isRoom">
            <span class="mdi mdi-cast-connected mdi-24px"></span>
          </button>
        </b-tooltip>
        <b-tooltip label="画面共有を停止" position="is-bottom" size="is-small" animated v-if="isConnect && isShare">
          <button class="button" style="background: transparent; border: none;" @click="$emit('shareScreen', false)" :disabled="!isRoom">
            <span class="mdi mdi-cast-off mdi-24px"></span>
          </button>
        </b-tooltip>
        <b-tooltip label="カメラをON" position="is-bottom" size="is-small" animated multilined v-if="isConnect && isBlind">
          <button class="button" style="background: transparent; border: none;" @click="$emit('videoSwitch', true)" :disabled="!isRoom">
            <span class="mdi mdi-camcorder mdi-24px"></span>
          </button>
        </b-tooltip>
        <b-tooltip label="カメラをOFF" position="is-bottom" size="is-small" animated multilined v-if="isConnect && !isBlind">
          <button class="button" style="background: transparent; border: none;" @click="$emit('videoSwitch', false)" :disabled="!isRoom">
            <span class="mdi mdi-camcorder-off mdi-24px"></span>
          </button>
        </b-tooltip>
        <b-tooltip label="マイクをON" position="is-bottom" size="is-small" animated multilined v-if="isConnect && isMute">
          <button class="button" style="background: transparent; border: none;" @click="$emit('audioSwitch', true)" :disabled="!isRoom">
            <span class="mdi mdi-microphone mdi-24px"></span>
          </button>
        </b-tooltip>
        <b-tooltip label="マイクをOFF" position="is-bottom" size="is-small" animated multilined v-if="isConnect && !isMute">
          <button class="button" style="background: transparent; border: none;" @click="$emit('audioSwitch', false)" :disabled="!isRoom">
            <span class="mdi mdi-microphone-off mdi-24px"></span>
          </button>
        </b-tooltip>
        <b-tooltip :label="!isRoom ? 'Web会議を始める際は椅子に着席してください' : 'クリックでWeb会議を開始します'" position="is-bottom" size="is-small" animated multilined v-if="!isConnect">
          <button class="button" style="background: transparent; border: none; color: #C82E42;" @click="$emit('connectVideo')" :disabled="!isRoom">
            <span class="mdi mdi-phone mdi-24px" style="margin-right: 4px;"></span>Web会議を始める
          </button>
        </b-tooltip>
        <b-tooltip label="退出する" position="is-bottom" size="is-small" animated multilined v-if="isConnect">
          <button class="button" style="background: transparent; border: none;" @click="$emit('disconnectVideo')" :disabled="!isRoom" v-if="isConnect">
            <span class="mdi mdi-phone-hangup mdi-24px" style="margin-right: 4px;"></span>
          </button>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HeaderMenu',
  componentName: 'HeaderMenu',
  props: ['isClose', 'isConnect', 'isMute', 'isBlind', 'isShare', 'isClose'],
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('virtualOffice', ['virtualOfficeList', 'userList']),
    isRoom () {
      for (const u of this.userList) {
        if (u.email === this.user.email && u.room) {
          return true
        }
      }
      return false
    },
    myStatus () {
      let idx = this.$_.findIndex(
        this.userList,
        ((obj) => { return obj.user_hash === this.user.userHash})
      )
      return this.userList[idx]
    }
  },
  data () {
    return {
      isEditOfficeName: false,
      officeName: null,
    }
  },
  mounted () {
    this.officeName = this.virtualOfficeList[0].name
  },
  methods: {
    updateVirtualOffice () {
      if (!this.officeName) {
        alert('オフィス名を１文字以上入力してください。')
        return
      }
      let updateData = {
        pk: this.virtualOfficeList[0].pk,
        name: this.officeName,
        company: this.user.companyPK
      }
      this.$store.dispatch('virtualOffice/updateVirtualOffice', updateData)
      this.isEditOfficeName = false
    },
    setWork (flg) {
      let msg = null
      if (flg) {
        msg = '[WORK_FALSE]'
      } else {
        msg = '[WORK_TRUE]'
      }
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV', msg)
    },
    setWorkOutSide (flg) {
      let msg = null
      if (flg) {
        msg = '[WORK_OUTSIDE_FALSE]'
      } else {
        msg = '[WORK_OUTSIDE_TRUE]'
      }
      this.$store.dispatch('virtualOffice/sendVirtualOfficeSV', msg)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-title {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.main-header {
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  border-bottom: solid thin #eee;
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/HeaderMenu.vue